/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShowThread200ResponseDataPostsInnerUser
 */
export interface ShowThread200ResponseDataPostsInnerUser {
    /**
     * 
     * @type {number}
     * @memberof ShowThread200ResponseDataPostsInnerUser
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShowThread200ResponseDataPostsInnerUser
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowThread200ResponseDataPostsInnerUser
     */
    username?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowThread200ResponseDataPostsInnerUser
     */
    bio?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowThread200ResponseDataPostsInnerUser
     */
    avatarUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowThread200ResponseDataPostsInnerUser
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowThread200ResponseDataPostsInnerUser
     */
    country?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ShowThread200ResponseDataPostsInnerUser
     */
    isAdmin?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ShowThread200ResponseDataPostsInnerUser
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowThread200ResponseDataPostsInnerUser
     */
    updatedAt?: string;
}

/**
 * Check if a given object implements the ShowThread200ResponseDataPostsInnerUser interface.
 */
export function instanceOfShowThread200ResponseDataPostsInnerUser(value: object): value is ShowThread200ResponseDataPostsInnerUser {
    return true;
}

export function ShowThread200ResponseDataPostsInnerUserFromJSON(json: any): ShowThread200ResponseDataPostsInnerUser {
    return ShowThread200ResponseDataPostsInnerUserFromJSONTyped(json, false);
}

export function ShowThread200ResponseDataPostsInnerUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowThread200ResponseDataPostsInnerUser {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'username': json['username'] == null ? undefined : json['username'],
        'bio': json['bio'] == null ? undefined : json['bio'],
        'avatarUrl': json['avatar_url'] == null ? undefined : json['avatar_url'],
        'city': json['city'] == null ? undefined : json['city'],
        'country': json['country'] == null ? undefined : json['country'],
        'isAdmin': json['is_admin'] == null ? undefined : json['is_admin'],
        'createdAt': json['created_at'] == null ? undefined : json['created_at'],
        'updatedAt': json['updated_at'] == null ? undefined : json['updated_at'],
    };
}

export function ShowThread200ResponseDataPostsInnerUserToJSON(json: any): ShowThread200ResponseDataPostsInnerUser {
    return ShowThread200ResponseDataPostsInnerUserToJSONTyped(json, false);
}

export function ShowThread200ResponseDataPostsInnerUserToJSONTyped(value?: ShowThread200ResponseDataPostsInnerUser | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'username': value['username'],
        'bio': value['bio'],
        'avatar_url': value['avatarUrl'],
        'city': value['city'],
        'country': value['country'],
        'is_admin': value['isAdmin'],
        'created_at': value['createdAt'],
        'updated_at': value['updatedAt'],
    };
}

